<div
  class="rounded-input box-border flex w-full flex-col text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    'bg-primary-on': !corporateDesignService.isDarkModeActive(),
  }"
  [ngStyle]="{
    borderRadius: borderRounding(),
    background: inputBackground(),
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div
    class="rounded-input relative w-full bg-inherit"
    [id]="id() | appendTestId: 'anchor'">
    <input
      [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
      [attr.data-testid]="id() | appendTestId: 'input'"
      autocomplete="off"
      (keydown.backspace)="ngControl.control!.setValue(undefined)"
      [formControl]="ngControl.control! | toFormControl"
      (click)="toggleList()"
      (focus)="isFocused.set(true)"
      (blur)="isFocused.set(false)"
      class="border-input-ring border-input rounded-input peer p-input w-full cursor-pointer bg-transparent placeholder-transparent focus:ring-0"
      [ngClass]="{
        'border-input-ring border-input rounded-input p-input':
          appearance() === 'default',
        'border-standard-outline-light bg-primary-on h-10 rounded-md border text-base font-medium':
          appearance() === 'compact',
        'border-input-error focus:border-input-focus': hasError,
        'border-input-ring focus:border-input-focus':
          !hasError && appearance() === 'default',
        'pointer-events-none': ngControl.disabled || isLoading(),
        'text-standard-text-dark': corporateDesignService.isDarkModeActive(),
        'text-standard-text': !corporateDesignService.isDarkModeActive(),
      }"
      [ngStyle]="{
        borderRadius: borderRounding(),
        borderColor: borderAndLabelColor(),
      }"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="text" />
    <span
      [attr.data-testid]="id() | appendTestId: 'value'"
      [ngClass]="{
        'top-3.5 right-6 bottom-3.5 left-4': appearance() === 'default',
        'top-1/2 right-9 left-3 -translate-y-1/2': appearance() === 'compact',
      }"
      class="pointer-events-none absolute flex items-center truncate bg-inherit"
      >
      @if (selectedOptionIcon()) {
        <span
          class="material-symbols-rounded mr-2 text-xl"
          aria-hidden="true"
          >{{ selectedOptionIcon() }}</span
        >
      }
      <span class="truncate" [ngClass]="corporateDesignService.baseFont()">
        {{
          name()
            ? (ngControl.value
              | SelectionOptionValueToName
                : options()
                : name()!
                : valueAttribute())
            : ngControl.value
              ? ngControl.value
              : ''
        }}
      </span>
    </span>
    @if (appearance() === 'default') {
      <label
        [attr.data-testid]="id() | appendTestId: 'label'"
        class="peer-placeholder-shown:text-input-text peer-focus:text-input-focus pointer-events-none absolute -top-2 right-4 left-4 w-fit max-w-[calc(100%-2rem)] cursor-text overflow-hidden bg-inherit text-sm overflow-ellipsis whitespace-nowrap transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
        [ngClass]="{
          'text-input-error': hasError,
          'text-input-focus': isFocused(),
          'text-standard-text-dark': corporateDesignService.isDarkModeActive(),
          'text-standard-text': !corporateDesignService.isDarkModeActive(),
        }"
        [ngStyle]="{color: borderAndLabelColor()}"
        [for]="id()">
        {{ formattedLabel() }}
      </label>
    }
    @if (
      !ngControl.control!.disabled &&
      ngControl.control!.value &&
      showResetIcon() &&
      !isLoading()
    ) {
      <span
        tabIndex="0"
        (keydown.enter)="
          searchControl.setValue(''); ngControl.control!.setValue('')
        "
        [ngStyle]="{
          background: inputBackground(),
        }"
        (click)="searchControl.setValue(''); ngControl.control!.setValue('')"
        [id]="id() | appendTestId: 'reset'"
        [attr.data-testid]="id() | appendTestId: 'reset'"
        class="material-symbols-rounded text-input-label absolute top-3 right-10 bottom-3 z-10 cursor-pointer text-2xl">
        close
      </span>
    }
    @if (!ngControl.control!.disabled && !isLoading()) {
      <span
        [id]="id() | appendTestId: 'arrow-down'"
        [ngStyle]="{
          background: inputBackground(),
        }"
        [attr.data-testid]="id() | appendTestId: 'arrow-down'"
        [ngClass]="{
          'top-3 right-4 bottom-3 h-8 text-2xl': appearance() === 'default',
          'top-1/2 right-3 -translate-y-1/2 text-[20px]':
            appearance() === 'compact',
        }"
        class="material-symbols-rounded text-input-label pointer-events-none absolute flex items-center">
        {{ showList() ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
      </span>
    }
    @if (isLoading()) {
      <span
        class="material-symbols-rounded pointer-events-none absolute top-3 right-4 bottom-3 animate-spin text-2xl"
        >progress_activity</span
      >
    }
    <ul
      tabindex="-1"
      [attr.data-testid]="id() | appendTestId: 'options'"
      [ngClass]="{
        hidden: !showList(),
        'bg-primary-on': !corporateDesignService.isDarkModeActive(),
        'bg-secondary-on': corporateDesignService.isDarkModeActive(),
      }"
      awPopupPosition
      [ngStyle]="{
        borderRadius: borderRounding(),
      }"
      class="focus:border-input-focus border-input-ring border-input rounded-input fixed z-10 -mt-px max-h-[300px] w-full overflow-y-auto focus:outline-hidden"
      [anchor]="id() | appendTestId: 'anchor'"
      [isVisible]="showList()">
      @if (searchable()) {
        <li class="sticky top-0 z-10 flex items-center bg-inherit px-3 py-2">
          <div class="relative min-w-0 flex-1">
            <span
              class="material-symbols-rounded text-input-label pointer-events-none absolute top-1/2 left-3 -translate-y-1/2"
              aria-hidden="true">
              search
            </span>
            <input
              [attr.data-bwignore]="ignoreBitwardenAutofill ? 'true' : null"
              type="search"
              autocomplete="off"
              [formControl]="searchControl"
              [attr.data-testid]="id() | appendTestId: 'search'"
              [placeholder]="searchPlaceholder()"
              class="focus:border-input-focus border-input-ring border-input rounded-input h-10 w-full bg-transparent pr-3 pl-10 focus:outline-none" />
          </div>
        </li>
      }

      @if (showClearOption() && options().length > 0) {
        <li
          [attr.data-testid]="id() | appendTestId: 'clear-option'"
          class="p-drop-down-list-item hover:bg-standard-hover-main min-h-[2.5rem] w-full cursor-pointer"
          (mouseenter)="menuSelectSupport.highlightedLink.set(-1)"
          (mouseleave)="menuSelectSupport.highlightedLink.set(undefined)"
          [style.color]="corporateDesignService.fontColor()"
          [style.border-top-left-radius]="
            !searchable() ? borderRounding() : undefined
          "
          [style.border-top-right-radius]="
            !searchable() ? borderRounding() : undefined
          "
          [style.background-color]="
            menuSelectSupport.highlightedLink() === -1
              ? menuSelectSupport.highlightedLinkBackgroundColor()
              : ''
          "
          (click)="clearSelection()">
          {{ clearOptionLabel() }}
        </li>
      }

      @for (option of filteredOptions(); track $index; let index = $index) {
        <li
          [attr.data-testid]="id() + index | appendTestId: 'option'"
          class="p-drop-down-list-item hover:bg-standard-hover-main min-h-[2.5rem] w-full cursor-pointer"
          [ngClass]="corporateDesignService.baseFont()"
          (mouseenter)="menuSelectSupport.highlightedLink.set($index)"
          (mouseleave)="menuSelectSupport.highlightedLink.set(undefined)"
          [style.color]="selectedItem() === $index
            ? menuSelectSupport.highlightedLinkColor()
            : ''
          "
          [style.border-top-left-radius]="
            !showClearOption() && index === 0 ? borderRounding() : undefined
          "
          [style.border-top-right-radius]="
            !showClearOption() && index === 0 ? borderRounding() : undefined
          "
          [style.border-bottom-left-radius]="
            index === filteredOptions().length - 1
              ? borderRounding()
              : undefined
          "
          [style.border-bottom-right-radius]="
            index === filteredOptions().length - 1
              ? borderRounding()
              : undefined
          "
          [style.background-color]="
            selectedItem() === $index 
              ? corporateDesignService.primaryColor() 
              : menuSelectSupport.highlightedLink() === $index
                ? menuSelectSupport.highlightedLinkBackgroundColor()
                : ''
          "
          (click)="selectOptionAndSetItem(option, index)">
          @let iconRaw =
            option && typeof option === 'object'
              ? (option | toSelectOptionAttribute: 'icon')
              : undefined;
          @let icon = typeof iconRaw === 'string' ? iconRaw : null;
          <div class="flex items-center">
            @if (icon) {
              <span
                class="material-symbols-rounded mr-2 text-xl"
                aria-hidden="true"
                >{{ icon }}</span
              >
            }
            <span>{{ option | toSelectOptionAttribute: name() }}</span>
          </div>
        </li>
      }

      @if (filteredOptions().length === 0) {
        <li class="px-3 py-2">
          {{
            textStore.texts()
              | filterTexts: ERelationType.noOptions : EEntityType.generic
              | language
          }}
        </li>
      }
    </ul>
  </div>
  @if (hasError && !errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-content></ng-content>
    </aw-error-message>
  }
  @if (hasError && errorTemplate()) {
    <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
      <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
    </aw-error-message>
  }
</div>
